import axios from "axios";
import { URLEMRPRESA } from "../config/index";

const axiosGenerico = axios.create({
  baseURL: `${URLEMRPRESA}`,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosGenerico.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosGenerico.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401 || error.response.status === 403) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      console.log("Sesión expirada");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosGenerico;
